export default __webpack_public_path__ + "static/media/DrinkPotion.6913b4bd.mp3";